import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { class: "markdown-edit-cell-grid" }

import { ref, inject, computed, nextTick, onBeforeMount, getCurrentInstance, onBeforeUnmount} from "vue";
import { marked } from 'marked';
import { findSelectableParent } from '../../util';
import { type BeakerSessionComponentType } from '../session/BeakerSession.vue';
import { type BeakerNotebookComponentType } from '../notebook/BeakerNotebook.vue';
import CodeEditor from '../misc/CodeEditor.vue';
import { IBeakerTheme } from '../../plugins/theme';


import { BeakerMarkdownCell } from "beaker-kernel/src";
const __default__ = {
    modelClass: BeakerMarkdownCell,
    icon: "pi pi-pencil",
};


export default /*@__PURE__*/_defineComponent({
  ...__default__,
  __name: 'BeakerMarkdownCell',
  props: [
    "cell"
],
  setup(__props, { expose: __expose }) {

const props = __props;

const instance = getCurrentInstance();
const beakerSession = inject<BeakerSessionComponentType>("beakerSession");
const cell = ref(props.cell);
const { theme } = inject<IBeakerTheme>('theme');
const isEditing = ref(false);
const editorRef = ref(null);
const codeEditorRef = ref(null);
const notebook = inject<BeakerNotebookComponentType>("notebook");
const editorContents = ref<string>(cell.value.source);

const renderedMarkdown = computed(() => {
    return marked.parse(props.cell?.source || "");
});

const clicked = (evt) => {
    notebook.selectCell(cell.value);
    evt.stopPropagation();
};

const execute = () => {
    isEditing.value = false;
    cell.value.source = editorContents.value;
}

const enter = () => {
    if (!isEditing.value) {
        isEditing.value = true;
    }

    nextTick(() => {
        codeEditorRef.value?.focus();
    });
}

const exit = () => {
    codeEditorRef.value?.blur();
    let target: HTMLElement = (instance.vnode.el as HTMLElement);
    const selectableParent = findSelectableParent(target);
    selectableParent?.focus();
}

const clear = () => {
    cell.value.source = "";
}

__expose({
    execute,
    enter,
    exit,
    clear,
    model: cell,
});

onBeforeMount(() => {
    marked.setOptions({
    //    gfm: true,
    //    sanitize: false,
    //    langPrefix: `language-`,
     });
    beakerSession.cellRegistry[cell.value.id] = instance.vnode;
})

onBeforeUnmount(() => {
    delete beakerSession.cellRegistry[cell.value.id];
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "markdown-cell",
    onDblclick: _cache[1] || (_cache[1] = ($event: any) => (enter()))
  }, [
    (!isEditing.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          innerHTML: renderedMarkdown.value
        }, null, 8, _hoisted_1))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", {
              class: _normalizeClass(["markdown-edit-data", {'dark-mode': _unref(theme).mode === 'dark'}]),
              ref: editorRef.value
            }, [
              _createVNode(CodeEditor, {
                modelValue: editorContents.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((editorContents).value = $event)),
                placeholder: "Your markdown...",
                ref_key: "codeEditorRef",
                ref: codeEditorRef,
                autofocus: false,
                language: "markdown",
                "display-mode": "dark",
                onClick: clicked
              }, null, 8, ["modelValue"])
            ], 2)
          ])
        ]))
  ], 32))
}
}

})